import React, { ChangeEvent } from "react";
import {  Form, Spinner } from "react-bootstrap";
import SelectBox from "../../../Components/SelectBox";
import Tick from "../../../icons/tick.svg?react";
import { QuestionData } from "..";
import styles from "../style.module.scss";
import SubmitButton from "../../../Components/Button";

interface question {
  complianceId: number;
  clauseId: number;
  questions: QuestionData[];
}
interface StateProps {
  selectedTemplate: string;
  currentStep: number;
  QuestionData: question[];
  setSelectedTemplate: (value: any) => void;
  setCurrentStep: (value: any) => void;
  renderButtonClass: () => string;
  sendQuestionnaires: () => void;
  btnDisable: boolean;
  loading: boolean;
  showToast: boolean;
}

const Template: React.FC<StateProps> = ({
  selectedTemplate,
  currentStep,
  QuestionData,
  setSelectedTemplate,
  sendQuestionnaires,
  setCurrentStep,
  btnDisable,
  showToast,
  loading,
}) => {
  const renderTemplate = () => {
    switch (selectedTemplate) {
      case "Template 1":
        return (
          <>
            <p>Subject: Request for Information [Audit Team] Questions</p>

            <p>Body:</p>

            <p>Hi Sir/Mam,</p>

            <p>
              You’ve been assigned a set of questions that need your attention.
            </p>

            <p>
              We're currently working on the [Audit Team] audit. To help us with
              this, we need you to provide some information by answering a set
              of questions.
            </p>
            <p>
              Please let us know if you encounter any issues accessing the link
              or providing your answers.
            </p>
            <p>Thanks.</p>
          </>
        );

      case "Template 2":
        return (
          <>
            <p>Subject: Request for Information [Audit Team] Questions</p>

            <p>Body:</p>

            <p>Hi Sir/Mam,</p>

            <p>
              You’ve been assigned a set of questions that need your attention.
            </p>

            <p>
              We're currently working on the [Audit Team] audit. To help us with
              this, we need you to provide some information by answering a set
              of questions.
            </p>
            <p className="text-decoration-underline">
              Please provide your answers directly within the designated
              response column on that page :
            </p>

            <p>
              <table className={styles.tableBorder}>
                <thead>
                  <tr>
                    <th>Assessment Question</th>
                    <th>Your Response</th>
                    <th>Document Name (if any)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Are quality assurance checks performed before product
                      release?
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>what is the quality of the Database?</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </p>
            <p>
              Please let us know if you encounter any issues accessing the link
              or providing your answers.
            </p>
            <p>Thanks.</p>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <div className={styles.wrapper}>
        <Form.Label className="fw-semibold">Select Email Template</Form.Label>
        <div className={styles.TemplateField}>
          <SelectBox
            name="emailTemplate"
            id="emailTemplate"
            defaultValue={selectedTemplate}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setSelectedTemplate(e.currentTarget.value)
            }
            options={[
              {
                label: "Template 1",
                value: "Template 1",
              },
              {
                label: "Template 2",
                value: "Template 2",
              },
            ]}
            className={styles.select}
          />
        </div>
        <label className="my-3 fw-semibold">
          {selectedTemplate} Description
        </label>
        <p className={styles.noteTemplate}>
          Note: This is a sample email template. You can edit the fields like
          name, deadline, and team name based on your use case. This is here to
          give you a heads-up on the email flow
        </p>
      </div>
      <div className={styles.templateBox}>{renderTemplate()}</div>
      <div className="d-flex justify-content-between p-3">
        <SubmitButton
          className={styles.confirmSelectionbtn}
          disabled={currentStep !== 2}
          onClick={() => setCurrentStep(1)}
        >
          Back
        </SubmitButton>
        <SubmitButton
          className={styles.submitSelectionbtn}
          onClick={() => sendQuestionnaires()}
          disabled={QuestionData.length === 0 || btnDisable}
        >
          {"Send Questionnaire"}&nbsp;&nbsp;{showToast && <Tick />}
          {loading && (
            <Spinner
              animation="border"
              variant="light"
              className={styles.submitLoader}
            />
          )}
        </SubmitButton>
      </div>
    </>
  );
};

export default Template;
